import { camelCase } from 'lodash';
import { AGENCY_BRANDS, BRAND, MY_BRANDS } from 'utils/brands';
import type { InfluencerMeta, InfluencerMetaByBrandType } from 'types';

function getEmptyMetaByBrand(): InfluencerMetaByBrandType {
  return {
    [camelCase(BRAND)]: [],
    [camelCase(MY_BRANDS)]: [],
    [camelCase(AGENCY_BRANDS)]: []
  } as any as InfluencerMetaByBrandType;
}

export function getDefaultMeta(): InfluencerMeta {
  return {
    lists: getEmptyMetaByBrand(),
    notes: getEmptyMetaByBrand(),
    campaigns: getEmptyMetaByBrand()
  };
}
